import { combineReducers } from '@reduxjs/toolkit';
import appConfigReducer from 'redux/appConfig/reducer';
import cauHinhDiaChiReducer from 'redux/cauHinhDiaChi/reducer';
import quanLyThanhToanReducer from 'redux/quanLyThanhToan/reducer';
import thongTinTaiKhoanReducer from 'redux/thongTinTaiKhoan/reducer';
import khieuNaiReducer from 'redux/khieuNai/reducer';
import QuanLyDonHangReducer from 'redux/QuanLyDonHang/reducer';
import {QuanLyTienHangReducer} from 'redux/quanLyTienHang/reducer';
import {ThongTinDonHangReducer} from 'redux/ThongTinDonhang/reducer';
import ThongBaoReducer from 'redux/thongBao/reducer';

const createRootReducer = () => {
  return combineReducers({
    appConfig: appConfigReducer,
    cauHinhDiaChiReducer,
    quanLyThanhToanReducer,
    thongTinTaiKhoanReducer,
    khieuNaiReducer,
    QuanLyDonHangReducer,
    QuanLyTienHangReducer,
    ThongTinDonHangReducer,
    ThongBaoReducer,
  });
};

export default createRootReducer;
